<div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in"
  (click)="closeDropdowns()">
  <!-- Modal Content Container -->
  <div
    class="relative w-full max-w-lg bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 p-6 md:p-8 animate-fade-in-up"
    (click)="onClickInsideModal($event)">

    <!-- Loading Overlay -->
    <div *ngIf="isLoading()"
      class="absolute inset-0 bg-white/70 dark:bg-slate-900/70 backdrop-blur-xs z-50 flex items-center justify-center rounded-[2rem]">
      <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
    </div>

    <!-- Title Header -->
    <div class="flex items-center justify-between mb-6 pb-4 border-b border-slate-100 dark:border-slate-800">
      <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">class</span>
        {{ formData.id ? 'แก้ไขกลุ่มเมนูย่อย' : 'สร้างกลุ่มเมนูย่อยใหม่' }}
      </h3>
      <button (click)="onClose()"
        class="w-8 h-8 rounded-lg flex items-center justify-center text-slate-400 hover:text-slate-600 hover:bg-slate-50 transition-colors">
        <span class="material-icons">close</span>
      </button>
    </div>

    <!-- Form Body -->
    <div class="space-y-5">
      <!-- Parent Group Menu Searchable Dropdown -->
      <div class="relative">
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">กลุ่มเมนูหลัก <span
            class="text-rose-500">*</span></label>
        <div
          class="relative w-full flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:bg-white focus-within:ring-2 focus-within:ring-amber-200 transition-all overflow-hidden h-[46px]"
          (click)="$event.stopPropagation()">
          <span class="absolute left-3 material-icons text-slate-400">folder</span>
          <input type="text" placeholder="พิมพ์เพื่อค้นหา..." [(ngModel)]="searchGroupMenuText"
            (focus)="onInputFocus('groupMenu')" (blur)="closeDropdowns()"
            class="w-full pl-10 pr-10 py-2 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:ring-0 focus:outline-none placeholder:text-slate-400">
          <button (click)="toggleDropdown('groupMenu', $event)"
            class="absolute right-2 text-slate-400 hover:text-slate-600 outline-none">
            <span class="material-icons text-lg transition-transform duration-200"
              [class.rotate-180]="openDropdown === 'groupMenu'">expand_more</span>
          </button>
        </div>

        <!-- Custom Dropdown Overlay -->
        <div *ngIf="openDropdown === 'groupMenu'" (mousedown)="$event.preventDefault()"
          (click)="$event.stopPropagation()"
          class="absolute top-full left-0 mt-2 w-full bg-white dark:bg-slate-800 rounded-2xl shadow-2xl border border-slate-100 dark:border-slate-700 max-h-48 overflow-y-auto z-45 py-2 custom-scrollbar">
          <div *ngFor="let opt of filteredGroupMenuOptions" (click)="selectGroupMenu(opt)"
            class="px-4 py-2 text-sm font-semibold hover:bg-amber-50 dark:hover:bg-amber-900/10 cursor-pointer transition-colors flex items-center justify-between"
            [ngClass]="formData.groupMenuId === opt.id ? 'text-amber-500 bg-amber-50 dark:bg-amber-900/10' : 'text-slate-600 dark:text-slate-300'">
            {{ opt.name }}
            <span *ngIf="formData.groupMenuId === opt.id" class="material-icons text-sm">check</span>
          </div>
          <div *ngIf="filteredGroupMenuOptions.length === 0"
            class="px-4 py-3 text-xs text-slate-400 text-center font-bold">ไม่พบข้อมูลกลุ่มเมนู</div>
        </div>
      </div>

      <!-- Group Sub Menu Name -->
      <div>
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ชื่อกลุ่มเมนูย่อย <span
            class="text-rose-500">*</span></label>
        <div
          class="relative w-full flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:bg-white focus-within:ring-2 focus-within:ring-amber-200 transition-all overflow-hidden h-[46px]">
          <span class="absolute left-3 material-icons text-slate-400">label</span>
          <input type="text" placeholder="ตัวอย่าง: จัดการที่จอดรถ" [(ngModel)]="formData.name"
            class="w-full pl-10 pr-4 py-2 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:ring-0 focus:outline-none placeholder:text-slate-400">
        </div>
      </div>

      <!-- Icon Name -->
      <div>
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ไอคอน (Material Icon
          Name)</label>
        <div
          class="relative w-full flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:bg-white focus-within:ring-2 focus-within:ring-amber-200 transition-all overflow-hidden h-[46px]">
          <span class="absolute left-3 material-icons text-slate-400">{{ formData.icon || 'star' }}</span>
          <input type="text" placeholder="ตัวอย่าง: local_parking" [(ngModel)]="formData.icon"
            class="w-full pl-10 pr-4 py-2 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:ring-0 focus:outline-none placeholder:text-slate-400">
        </div>
      </div>

      <!-- Order Number -->
      <div>
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ลำดับการแสดงผล <span
            class="text-rose-500">*</span></label>
        <div
          class="relative w-full flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:bg-white focus-within:ring-2 focus-within:ring-amber-200 transition-all overflow-hidden h-[46px]">
          <span class="absolute left-3 material-icons text-slate-400">format_list_numbered</span>
          <input type="number" placeholder="ตัวอย่าง: 1" [(ngModel)]="formData.number" min="1"
            class="w-full pl-10 pr-4 py-2 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:ring-0 focus:outline-none placeholder:text-slate-400">
        </div>
      </div>

      <!-- Toggle Status -->
      <div
        class="flex items-center justify-between p-4 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-100 dark:border-slate-800">
        <div>
          <h4 class="text-sm font-bold text-slate-700 dark:text-slate-300">เปิดใช้งานกลุ่มเมนูย่อย</h4>
          <p class="text-[11px] text-slate-400 mt-0.5">เปิดหรือปิดการแสดงผลหมวดหมู่ย่อยนี้</p>
        </div>
        <div class="relative inline-flex items-center cursor-pointer" (click)="formData.enable = !formData.enable">
          <input type="checkbox" class="sr-only peer" [checked]="formData.enable">
          <div
            class="w-11 h-6 bg-slate-200 peer-focus:outline-none dark:bg-slate-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-slate-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-emerald-500 rounded-full shadow-inner">
          </div>
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="flex items-center justify-between gap-3 mt-8 pt-4 border-t border-slate-100 dark:border-slate-800">
      <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()" [disabled]="isLoading()"
        class="px-5 py-2.5 border border-slate-200 dark:border-slate-700 hover:border-amber-400 hover:text-amber-600 text-slate-600 dark:text-slate-300 font-bold rounded-xl shadow-sm transition-all active:scale-95 inline-flex items-center gap-1.5 cursor-pointer disabled:opacity-50">
        <span class="material-icons text-base">history</span>
        ดูประวัติ
      </button>
      <div class="flex items-center justify-end gap-3 ml-auto">
        <button (click)="onClose()"
          class="px-5 py-2.5 bg-slate-50 dark:bg-slate-800 hover:bg-slate-100 text-slate-500 dark:text-slate-400 font-bold rounded-xl shadow-sm transition-all active:scale-95">ยกเลิก</button>
        <button (click)="onSave()"
          class="px-6 py-2.5 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl shadow-lg hover:shadow-amber-400/20 hover:-translate-y-0.5 transition-all active:scale-95">บันทึก</button>
      </div>
    </div>

  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && formData.id"
  [entityType]="activityEntityTypes.GroupSubMenu"
  [entityId]="formData.id!"
  title="ประวัติกลุ่มเมนูย่อย"
  [subtitle]="'#' + formData.id"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>